module.exports = __webpack_public_path__ + "static/media/Kabuto_gaussian2.05cf57d0.png";